var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "container-fluid pl-0 pr-0",
      attrs: { id: "visitor-history" },
    },
    [
      _c(
        "b-row",
        { attrs: { id: "visitor-history-row" } },
        [
          _c(
            "b-col",
            { attrs: { cols: "2" } },
            [
              _c(
                "b-form-group",
                {
                  staticClass: "mb-1 custom-input",
                  attrs: {
                    id: "start-date-input-group",
                    label: _vm.$t("message.first"),
                    "label-for": "start-date-input",
                    "label-sr-only": "",
                  },
                },
                [
                  _c("datetime", {
                    attrs: {
                      "max-datetime": _vm.maxDate,
                      "min-datetime": _vm.lastFiveYear,
                      phrases: _vm.phrases,
                      placeholder: _vm.$t("message.startDate"),
                      auto: "",
                      "input-class": "form-control rounded-0",
                      "input-id": "start-date-input",
                      type: "datetime",
                    },
                    on: { input: _vm.saveDate },
                    model: {
                      value: _vm.startDate,
                      callback: function ($$v) {
                        _vm.startDate = $$v
                      },
                      expression: "startDate",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { cols: "2" } },
            [
              _c(
                "b-form-group",
                {
                  staticClass: "mb-1 custom-input",
                  attrs: {
                    id: "end-date-input-group",
                    label: _vm.$t("message.last"),
                    "label-for": "end-date-input",
                    "label-sr-only": "",
                  },
                },
                [
                  _c("datetime", {
                    attrs: {
                      "max-datetime": _vm.maxDate,
                      "min-datetime": _vm.lastFiveYear,
                      phrases: _vm.phrases,
                      placeholder: _vm.$t("message.endDate"),
                      auto: "",
                      "input-class": "form-control rounded-0",
                      "input-id": "end-date-input",
                      type: "datetime",
                    },
                    on: { input: _vm.saveFilters },
                    model: {
                      value: _vm.endDate,
                      callback: function ($$v) {
                        _vm.endDate = $$v
                      },
                      expression: "endDate",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { cols: "2" } },
            [
              _c(
                "b-form-group",
                {
                  staticClass: "mb-1 custom-input",
                  attrs: {
                    id: "query-input-group",
                    label: _vm.$t("message.query"),
                    "label-for": "query-input",
                    "label-sr-only": "",
                  },
                },
                [
                  _c("b-form-input", {
                    staticClass: "rounded-0",
                    attrs: {
                      id: "query-input",
                      placeholder: _vm.$t("message.query"),
                      name: "query",
                    },
                    on: { change: _vm.saveFilters },
                    model: {
                      value: _vm.query,
                      callback: function ($$v) {
                        _vm.query = $$v
                      },
                      expression: "query",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "custom-input" },
            [
              _c("a-rate", {
                attrs: { "allow-clear": true },
                on: { change: _vm.saveFilters },
                model: {
                  value: _vm.point,
                  callback: function ($$v) {
                    _vm.point = $$v
                  },
                  expression: "point",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { cols: "2" } },
            [
              _c(
                "b-form-group",
                { staticClass: "mb-1 custom-input" },
                [
                  _c(
                    "b-form-select",
                    {
                      staticClass: "mb-3",
                      on: { change: _vm.saveFilters },
                      model: {
                        value: _vm.selectedUser,
                        callback: function ($$v) {
                          _vm.selectedUser = $$v
                        },
                        expression: "selectedUser",
                      },
                    },
                    [
                      _c("option", { domProps: { value: null } }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.$t("message.allUsers")) +
                            "\n                    "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "only-chatbot" } }, [
                        _vm._v(_vm._s(_vm.$t("message.chatBot"))),
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.usersFilter.data, function (item) {
                        return _c(
                          "option",
                          { key: item._id, domProps: { value: item._id } },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(item.name) +
                                "\n                    "
                            ),
                          ]
                        )
                      }),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { cols: "2" } },
            [
              _c(
                "b-form-group",
                {
                  staticClass: "mb-1 custom-input",
                  attrs: { id: "query-input-group3" },
                },
                [
                  _c(
                    "b-form-select",
                    {
                      staticClass: "mb-3",
                      on: { change: _vm.saveFilters },
                      model: {
                        value: _vm.selectedCustomerDomains,
                        callback: function ($$v) {
                          _vm.selectedCustomerDomains = $$v
                        },
                        expression: "selectedCustomerDomains",
                      },
                    },
                    [
                      _c("option", { domProps: { value: null } }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.$t("message.allSites")) +
                            "\n                    "
                        ),
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.customerDomains, function (site) {
                        return _c(
                          "option",
                          { key: site, domProps: { value: site } },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(site) +
                                "\n                    "
                            ),
                          ]
                        )
                      }),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "tableSettingsBtn",
          staticStyle: { position: "absolute", left: "8px" },
        },
        [
          _c("a-icon", {
            directives: [
              {
                name: "tippy",
                rawName: "v-tippy",
                value: {
                  followCursor: true,
                  placement: "bottom-end",
                  theme: _vm.isDarkMode ? "light-border" : "google",
                },
                expression:
                  "{\n                followCursor: true,\n                placement: 'bottom-end',\n                theme: isDarkMode ? 'light-border' : 'google',\n            }",
              },
            ],
            style: { color: "#3699FF" },
            attrs: {
              id: "tableSettingsButton",
              content: _vm.$t("message.tableSettingTippy"),
              "data-v-step": "12",
              type: "setting",
            },
            on: { click: _vm.openVisitorHistorySettingsModal },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("a-table", {
        key: "vh-table-" + _vm.renderCount,
        staticClass: "custom-table",
        attrs: {
          columns: _vm.columns,
          dataSource: _vm.visitors.data,
          loading: _vm.loading,
          locale: {
            emptyText: _vm.$t("message.noVisitorFound"),
          },
          pagination: false,
          rowKey: "_id",
          size: "small",
        },
        on: { change: _vm.tableChange },
        scopedSlots: _vm._u(
          [
            _vm._l(_vm.customLoginInputs, function (input, i) {
              return {
                key: input._id,
                fn: function (data, item) {
                  return [
                    _c("div", { key: input._id, staticClass: "ellipsis" }, [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.getInputValue(item, input)) +
                          "\n            "
                      ),
                    ]),
                  ]
                },
              }
            }),
            {
              key: "_country",
              fn: function (data, item) {
                return _c("div", {}, [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        item.geoLocation ? item.geoLocation.country : "N/A"
                      ) +
                      "\n        "
                  ),
                ])
              },
            },
            {
              key: "_createdDate",
              fn: function (data, item) {
                return _c("div", {}, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm._f("dateShorted")(item.createdDate)) +
                      "\n        "
                  ),
                ])
              },
            },
            {
              key: "_destroyedDate",
              fn: function (data, item) {
                return _c("div", {}, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm._f("dateShorted")(item.destroyedDate)) +
                      "\n        "
                  ),
                ])
              },
            },
            {
              key: "_timeSpent",
              fn: function (data, item) {
                return _c(
                  "div",
                  {},
                  [
                    _c("PassedTimeCounterTimeFormat", {
                      attrs: {
                        date: item.connectedDate,
                        endDate: item.destroyedDate,
                      },
                    }),
                  ],
                  1
                )
              },
            },
            {
              key: "_star",
              fn: function (data, item) {
                return _c("div", {}, [
                  _vm._v(
                    "\n            " + _vm._s(item.point || "-") + "\n        "
                  ),
                ])
              },
            },
            {
              key: "_user",
              fn: function (data, item) {
                return _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "tippy",
                        rawName: "v-tippy",
                        value: {
                          followCursor: true,
                          placement: "bottom-end",
                          theme: _vm.isDarkMode ? "light-border" : "google",
                        },
                        expression:
                          "{\n                followCursor: true,\n                placement: 'bottom-end',\n                theme: isDarkMode ? 'light-border' : 'google',\n            }",
                      },
                    ],
                    attrs: { content: _vm.getUserNames(item) },
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.getUserNames(item).length > 15
                            ? _vm.getUserNames(item).slice(0, 11) + "..."
                            : _vm.getUserNames(item)
                        ) +
                        "\n        "
                    ),
                  ]
                )
              },
            },
            {
              key: "_actions",
              fn: function (data, item) {
                return _c("div", {}, [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "flex-direction": "column",
                      },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticStyle: {
                            display: "flex",
                            "flex-direction": "row",
                          },
                        },
                        [
                          _c(
                            "a-button",
                            {
                              staticClass:
                                "actionButton d-flex align-items-center classic-button",
                              attrs: { size: "small" },
                              on: {
                                click: function ($event) {
                                  return _vm.clickLine(item)
                                },
                              },
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    "margin-right": "3px",
                                    display: "block",
                                    "font-size": "12px",
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("message.userProfile")))]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _vm.isWABusiness(item)
                            ? _c(
                                "a-button",
                                {
                                  staticClass:
                                    "actionButton d-flex align-items-center classic-button",
                                  attrs: { size: "small" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.startWhatsappChat(item)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        "margin-right": "3px",
                                        display: "block",
                                        "font-size": "12px",
                                      },
                                    },
                                    [_vm._v("Start Chat")]
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isWhatsappV1(item)
                            ? _c(
                                "a-button",
                                {
                                  staticClass:
                                    "actionButton d-flex align-items-center classic-button",
                                  attrs: { size: "small" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.startWhatsappChat(item)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        "margin-right": "3px",
                                        display: "block",
                                        "font-size": "12px",
                                      },
                                    },
                                    [_vm._v("Start Chat")]
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isWhatsappV2(item)
                            ? _c(
                                "a-button",
                                {
                                  staticClass:
                                    "actionButton d-flex align-items-center classic-button",
                                  attrs: { size: "small" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.startWhatsappChat(item)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        "margin-right": "3px",
                                        display: "block",
                                        "font-size": "12px",
                                      },
                                    },
                                    [_vm._v("Start Chat")]
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass:
                                "actionButton d-flex align-items-center background-transparent",
                              attrs: { size: "small" },
                              on: {
                                click: function ($event) {
                                  return _vm.view(item._id, item.index)
                                },
                              },
                            },
                            [_c("EyesIcon")],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ])
              },
            },
          ],
          null,
          true
        ),
      }),
      _vm._v(" "),
      _vm.visible
        ? _c(
            "Modal2",
            {
              attrs: {
                id: "visitor-history-modal",
                visible: _vm.visible,
                title: _vm.$t("message.visitorHistory"),
                description: _vm.$t("message.visitorHistoryDescription"),
                "show-footer": false,
                maskClosable: false,
                width: 1000,
              },
              on: {
                cancel: function ($event) {
                  _vm.visible = false
                },
              },
            },
            [
              _vm.filteredMessages.length
                ? _c("div", { staticClass: "filteredMessages" }, [
                    _c("div", { staticClass: "filteredMessages" }, [
                      _c("div", { staticClass: "parent-div" }, [
                        _c("div", [
                          _c("div", { staticClass: "display-flex" }, [
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "tippy",
                                    rawName: "v-tippy",
                                    value: {
                                      followCursor: true,
                                      placement: "bottom-end",
                                    },
                                    expression:
                                      "{ followCursor: true, placement: 'bottom-end' }",
                                  },
                                ],
                                staticClass: "icon material-icons",
                                attrs: { content: _vm.$t("coupon.name") },
                              },
                              [_vm._v("person")]
                            ),
                            _vm._v(
                              "\n                            " +
                                _vm._s(
                                  _vm.selectedHistory.visitor.fullname || "-"
                                ) +
                                "\n                        "
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _c("div", { staticClass: "display-flex" }, [
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "tippy",
                                    rawName: "v-tippy",
                                    value: {
                                      followCursor: true,
                                      placement: "bottom-end",
                                    },
                                    expression:
                                      "{ followCursor: true, placement: 'bottom-end' }",
                                  },
                                ],
                                staticClass: "icon material-icons",
                                attrs: { content: _vm.$t("coupon.email") },
                              },
                              [_vm._v("mail")]
                            ),
                            _vm._v(
                              "\n                            " +
                                _vm._s(
                                  _vm.selectedHistory.visitor.email || "-"
                                ) +
                                "\n                        "
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _c("div", { staticClass: "display-flex" }, [
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "tippy",
                                    rawName: "v-tippy",
                                    value: {
                                      followCursor: true,
                                      placement: "bottom-end",
                                    },
                                    expression:
                                      "{ followCursor: true, placement: 'bottom-end' }",
                                  },
                                ],
                                staticClass: "icon material-icons",
                                attrs: { content: _vm.$t("coupon.phone") },
                              },
                              [_vm._v("phone")]
                            ),
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.getPhoneNumber()) +
                                "\n                        "
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        !_vm.visitor.isBlocked
                          ? _c(
                              "div",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.ban()
                                  },
                                },
                              },
                              [
                                _c("div", { staticClass: "display-flex" }, [
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "tippy",
                                          rawName: "v-tippy",
                                          value: {
                                            followCursor: true,
                                            placement: "bottom-end",
                                          },
                                          expression:
                                            "{ followCursor: true, placement: 'bottom-end' }",
                                        },
                                      ],
                                      staticClass: "icon material-icons",
                                      attrs: {
                                        content: _vm.$t("message.block_"),
                                      },
                                    },
                                    [_vm._v("block")]
                                  ),
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(_vm.$t("message.block_")) +
                                      "\n                        "
                                  ),
                                ]),
                              ]
                            )
                          : _c(
                              "div",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.unban()
                                  },
                                },
                              },
                              [
                                _c("div", { staticClass: "display-flex" }, [
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "tippy",
                                          rawName: "v-tippy",
                                          value: {
                                            followCursor: true,
                                            placement: "bottom-end",
                                          },
                                          expression:
                                            "{ followCursor: true, placement: 'bottom-end' }",
                                        },
                                      ],
                                      staticClass: "icon material-icons",
                                      attrs: {
                                        content: _vm.$t("message.block_"),
                                      },
                                    },
                                    [_vm._v("block")]
                                  ),
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(_vm.$t("message.block_")) +
                                      " Kaldır\n                        "
                                  ),
                                ]),
                              ]
                            ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "display-flex" },
                          [
                            _c(
                              "vue-excel-xlsx",
                              {
                                staticClass: "download-button",
                                staticStyle: {
                                  "justify-self": "end",
                                  width: "36px",
                                  "align-self": "center",
                                },
                                attrs: {
                                  columns: _vm.downloadConversationFields(),
                                  data: _vm.downloadConversationData(),
                                  fileName: _vm.downloadConversationName,
                                  sheetName: "Page 1",
                                },
                              },
                              [
                                _c(
                                  "md-icon",
                                  { staticClass: "material-icons" },
                                  [_vm._v("download")]
                                ),
                              ],
                              1
                            ),
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.$t("message.download")) +
                                "\n                    "
                            ),
                          ],
                          1
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _vm.filteredMessages.length
                      ? _c(
                          "div",
                          {
                            directives: [
                              { name: "chat-scroll", rawName: "v-chat-scroll" },
                            ],
                            staticClass: "messages",
                          },
                          [
                            _c("MessageList", {
                              attrs: {
                                "always-scroll-to-bottom": false,
                                colors: _vm.colors,
                                messages: _vm.getMessages(),
                                participants: _vm.getParticipants(),
                                contextMenuVisable: false,
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "back-and-forth-button" },
                      [
                        _c(
                          "a-button",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.navigateHistory(-1)
                              },
                            },
                          },
                          [_vm._v(" <")]
                        ),
                        _vm._v(" "),
                        _c(
                          "a-button",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.navigateHistory(1)
                              },
                            },
                          },
                          [_vm._v(" >")]
                        ),
                      ],
                      1
                    ),
                  ])
                : _c(
                    "div",
                    [
                      _c("b-alert", { attrs: { show: "", variant: "info" } }, [
                        _vm._v(_vm._s(_vm.$t("message.chatNotFound"))),
                      ]),
                    ],
                    1
                  ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticStyle: { display: "flex" } }, [
        _c(
          "div",
          {
            staticStyle: {
              display: "flex",
              "justify-content": "flex-end",
              "margin-top": "6px",
              "margin-left": "auto",
            },
          },
          [
            _c(
              "IconButton",
              {
                directives: [
                  {
                    name: "tippy",
                    rawName: "v-tippy",
                    value: { content: "Sayfayı İndir" },
                    expression: "{ content: 'Sayfayı İndir' }",
                  },
                ],
                staticStyle: { "margin-top": "4px", "margin-right": "10px" },
                attrs: { onClick: _vm.exportToExcel },
              },
              [
                _c("md-icon", { staticStyle: { color: "#ffa800" } }, [
                  _vm._v("sim_card_download"),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "IconButton",
              {
                directives: [
                  {
                    name: "tippy",
                    rawName: "v-tippy",
                    value: { content: "Tüm Veriyi İndir" },
                    expression: "{ content: 'Tüm Veriyi İndir' }",
                  },
                ],
                staticStyle: { "margin-top": "4px", "margin-right": "10px" },
                attrs: { onClick: _vm.downloadAsFile },
              },
              [
                _c("md-icon", { staticStyle: { color: "#ffa800" } }, [
                  _vm._v("cloud_download"),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _c("Pagination", {
              attrs: {
                "page-change": _vm.pageChange,
                pageSizes: _vm.pageSizes,
                total: _vm.visitors.total,
                pageSizeLocalStorageKey: "visitor-history-page-size",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _vm.visitorHistorySettingsModalVisible
        ? _c(
            "Modal2",
            {
              attrs: {
                id: "tableColumns",
                title: _vm.$t("message.tableSettings"),
                "show-footer": false,
              },
              on: { cancel: _vm.closeVisitorHistorySettingsModal },
            },
            [
              _c("div", [
                _vm._v("Tabloda Görmek İstediğiniz Sütunları Seçiniz"),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "tableSettings" },
                _vm._l(_vm.defaultCols, function (col, i) {
                  return col.key !== "actions"
                    ? _c("div", { key: col.key }, [
                        _c("div", { staticClass: "item" }, [
                          _c(
                            "div",
                            { staticClass: "checkbox-group" },
                            [
                              _c(
                                "b-form-checkbox",
                                {
                                  attrs: {
                                    disabled:
                                      Object.values(_vm.tableCols).filter(
                                        function (x) {
                                          return x === true
                                        }
                                      ).length > 12 &&
                                      !_vm.tableCols[col.key] &&
                                      _vm.customLoginFormEnabled,
                                  },
                                  on: { input: _vm.toLocalStorage },
                                  model: {
                                    value: _vm.tableCols[col.key],
                                    callback: function ($$v) {
                                      _vm.$set(_vm.tableCols, col.key, $$v)
                                    },
                                    expression: "tableCols[col.key]",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(col.title) +
                                      "\n                        "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        i % 2 === 1
                          ? _c("div", { staticClass: "clear" })
                          : _vm._e(),
                      ])
                    : _vm._e()
                }),
                0
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }